import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IReferral } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-referral-toolbar',
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './referral-toolbar.component.html',
  styleUrl: './referral-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralToolbarComponent {
  referral = input.required<WithRef<IReferral>>();
  isSaving = input<boolean>(false);
}
